var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13148 0.751953C6.13148 0.475811 5.90762 0.251953 5.63148 0.251953C5.35534 0.251953 5.13148 0.475811 5.13148 0.751953V4.91863H0.964844C0.688701 4.91863 0.464844 5.14249 0.464844 5.41863C0.464844 5.69478 0.688701 5.91863 0.964844 5.91863H5.13148V10.0853C5.13148 10.3614 5.35534 10.5853 5.63148 10.5853C5.90762 10.5853 6.13148 10.3614 6.13148 10.0853V5.91863H10.2982C10.5743 5.91863 10.7982 5.69478 10.7982 5.41863C10.7982 5.14249 10.5743 4.91863 10.2982 4.91863H6.13148V0.751953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhiteIcon);
export default __webpack_public_path__ + "static/media/plus-white-icon.26793b26368ea55c7de1ebfa9ae0c6af.svg";
export { ForwardRef as ReactComponent };